<template>
  <div>
    <v-expansion-panels flat v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header>
          Active people ({{ activePersons.length }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mb-2">
            <v-col>
              <v-btn
                depressed
                tile
                :disabled="readonly || disableInput"
                class="ma-0"
                @click="add"
              >
                <v-icon>
                  add
                </v-icon>
                Add person
              </v-btn>
            </v-col>
          </v-row>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>MSA ID</th>
                  <th>Admin</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Position</th>
                  <th>Start</th>
                  <th>End</th>
                  <th>Training</th>
                  <th class="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="linkage of activePersons" :key="linkage._id">
                  <td :class="{ 'font-weight-bold': linkage.isPrimaryContact }">{{ linkage.person.name }}</td>
                  <td>{{ linkage.person.personId }}</td>
                  <td>
                    <v-checkbox
                      :input-value="linkage.isAdminForRegistration"
                      :disabled="readonly || disableInput || linkage.isPrimaryContact"
                      @change="toggleIsAdminForRegistration(linkage)"
                    />
                  </td>
                  <td>{{ linkage.person.email }}</td>
                  <td>{{ linkage.person.phoneNumber }}</td>
                  <td>{{ linkage.position }}</td>
                  <td>{{ linkage.start | formatDate }}</td>
                  <td>{{ linkage.end | formatDate }}</td>

                  <td>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          :disabled="readonly"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>assessment</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="openAssmentHistory(linkage.personId)" :disabled="disableInput">
                          <v-list-item-icon><v-icon>assessment</v-icon></v-list-item-icon>
                          <v-list-item-title>Show Assessment History</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="startEndUserTraining(linkage)" :disabled="disableInput">
                          <v-list-item-title>Invite for end-user training</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>

                  <td class="text-end">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          :disabled="readonly"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>menu_open</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-if="enablePersonSearch"
                          @click="$router.push({ name: 'AdminPerson', params: { id: linkage.person._id } })"
                          :disabled="disableInput"
                        >
                          <v-list-item-icon><v-icon>launch</v-icon></v-list-item-icon>
                          <v-list-item-title>Manage Person</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click="openEdit(linkage)"
                          :disabled="disableInput"
                        >
                          <v-list-item-icon><v-icon>edit</v-icon></v-list-item-icon>
                          <v-list-item-title>Edit Details</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click="replacePrimaryContact(linkage)"
                          :disabled="linkage.isPrimaryContact || disableInput"
                        >
                          <v-list-item-icon><v-icon>supervisor_account</v-icon></v-list-item-icon>
                          <v-list-item-title>Set as primary contact</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click="disableLink(linkage._id)"
                          :disabled="linkage.isPrimaryContact || linkage.sourceOfTruth === SourceOfTruth.LPA || disableInput"
                        >
                          <v-list-item-icon><v-icon>link_off</v-icon></v-list-item-icon>
                          <v-list-item-title>Unlink Person</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>

                <tr v-show="!activePersons.length">
                  <td colspan="10" class="text-center">
                    {{ $apollo.queries.registration.loading ? 'Loading...' : 'This member has no people.' }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          Inactive people ({{ inactivePersons.length }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>MSA ID</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Position</th>
                  <th>Start</th>
                  <th>End</th>
                  <th class="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="linkage of inactivePersons" :key="linkage._id">
                  <td :class="{ 'font-weight-bold': linkage.isPrimaryContact }">{{ linkage.person.name }}</td>
                  <td>{{ linkage.person.personId }}</td>
                  <td>{{ linkage.person.email }}</td>
                  <td>{{ linkage.person.phoneNumber }}</td>
                  <td>{{ linkage.position }}</td>
                  <td>{{ linkage.start | formatDate }}</td>
                  <td>{{ linkage.end | formatDate }}</td>
                  <td class="text-end">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          :disabled="readonly"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>menu_open</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          @click="enableLink(linkage._id)"
                          :disabled="disableInput"
                        >
                          <v-list-item-icon><v-icon>link_on</v-icon></v-list-item-icon>
                          <v-list-item-title>Reinstate access</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog
      v-model="dialog"
      width="800"
    >
      <v-card>
        <v-card-text>
          <v-row class="pt-5">
            <v-col>
              Personal details
              <person-form
                v-model="personForm"
                @valid="personValid = $event"
              />
              <v-form v-model="linkageFormValid">
                <template v-if="enablePersonSearch">
                  <v-alert
                    type="warning"
                    outlined
                    dense
                    v-show="existingPeople.length"
                  >
                    <strong>{{ existingPeople.length }} {{ 'person' | pluralize(existingPeople.length) }} found</strong>
                    <v-select
                      v-model="linkageForm.existingPersonId"
                      label="Person"
                      :items="existingPeople"
                      item-text="name"
                      item-value="_id"
                      clearable
                      hint="Leave this value blank to add a new person"
                      persistent-hint
                    >
                      <template v-slot:item="data">
                        <v-list-item-content>
                          <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                          <v-list-item-subtitle><v-icon x-small>perm_identity</v-icon> {{ data.item.personId }}</v-list-item-subtitle>
                          <v-list-item-subtitle><v-icon x-small>email</v-icon> {{ data.item.email }}</v-list-item-subtitle>
                          <v-list-item-subtitle><v-icon x-small>smartphone</v-icon> {{ data.item.phoneNumber }}</v-list-item-subtitle>
                          <v-list-item-subtitle><v-icon x-small>groups</v-icon> {{ data.item.registrations.map(r => r.registration.memberNumber).filter(Boolean).join(', ') }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-select>
                    <v-simple-table dense v-if="existingPerson">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th>Member Number</th>
                            <th>Member Name</th>
                            <th>Position</th>
                            <th>From</th>
                            <th>To</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="linkage of existingPerson.registrations" :key="linkage._id">
                            <td>{{ linkage.registration.memberNumber }}</td>
                            <td>{{ linkage.registration.memberName }}</td>
                            <td>{{ linkage.position }}</td>
                            <td>{{ linkage.start | formatDate }}</td>
                            <td>{{ linkage.end | formatDate }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-alert>
                </template>

                <v-divider class="mt-3" />
                Position details
                <v-text-field
                  label="Position"
                  v-model="linkageForm.position"
                  :rules="positionRules"
                  required
                />

                <v-checkbox
                  label="Create login"
                  v-model="linkageForm.createAccount"
                />
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="save"
            :disabled="(!existingPerson && !personValid) || !linkageFormValid || disableInput"
          >
            Save
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="assessmentDialog"
      width="800"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Assessment History
        </v-card-title>

        <v-card-text>
          <member-trainee-assessment-table
            v-if="selectedPersonId"
            :registrationId="registrationId"
            :personId="selectedPersonId"
            v-bubble.error
            v-bubble.info
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="assessmentDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { SourceOfTruth } from '@mymsa/common'
import MemberTraineeAssessmentTable from './MemberTraineeAssessmentTable.vue'
import PersonForm from '../components/forms/PersonForm.vue'

function sort (a, b) {
  return a.person?.givenName?.localeCompare(b.person?.givenName) ||
    a.person?.familyName?.localeCompare(b.person?.familyName) ||
    (new Date(a.start) - new Date(b.start))
}

export default {
  name: 'RegistrationPersons',

  components: {
    MemberTraineeAssessmentTable,
    PersonForm
  },

  props: {
    registrationId: {
      type: String,
      required: true
    },
    enablePersonSearch: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    SourceOfTruth,
    panel: 0,
    registration: {
      persons: []
    },
    personForm: {},
    _personForm: {},
    linkageForm: {
      createAccount: true
    },
    dialog: false,
    assessmentDialog: false,
    selectedPersonId: null,
    existingPeople: [],
    saving: false,
    personValid: false,
    isNew: false,
    linkageFormValid: false,
    positionRules: [
      v => !!v || 'Position is required'
    ]
  }),

  computed: {
    activePersons () {
      return this.registration.persons
        .filter(linkage => linkage.isActive)
        .sort(sort)
    },

    inactivePersons () {
      return this.registration.persons
        .filter(linkage => !linkage.isActive)
        .sort(sort)
    },

    existingPersonSelected () {
      return !!this.linkageForm.existingPersonId
    },

    existingPerson () {
      const { existingPersonId } = this.linkageForm
      if (!existingPersonId) return null
      return this.existingPeople.find(o => o._id === existingPersonId)
    },

    disableInput () {
      return this.saving || this.$apollo.queries.registration.loading
    }
  },

  watch: {
    'linkageForm.existingPersonId' (existingPersonId) { // Show person details in form fields, revert if cleared.
      if (existingPersonId) {
        this._personForm = this.personForm
        const person = this.existingPeople.find(o => o._id === existingPersonId)
        this.personForm = person
      } else {
        this.personForm = this._personForm
      }
    }
  },

  apollo: {
    registration: {
      query: gql`query GetRegistrationPersons($id: MongoID!) {
        registration: registrationById(_id: $id) {
          _id
          memberNumber
          persons {
            _id
            position
            start
            end
            isActive
            isPrimaryContact
            isAdminForRegistration
            sourceOfTruth
            personId
            person {
              _id
              personId
              name
              givenName
              familyName
              email
              phoneNumber
            }
          }
        }
      }`,
      variables () {
        return {
          id: this.registrationId
        }
      }
    },
    existingPeople: {
      query: gql`query RegistrationPersonsSearchPersons($search: FilterSearchManyPersonInput!) {
        existingPeople: personSearchMany(search: $search) {
          _id
          personId
          name
          givenName
          familyName
          email
          phoneNumber
          registrations {
            _id
            start
            end
            position
            registration {
              _id
              memberNumber
              memberName
            }
          }
        }
      }`,
      variables () {
        return {
          search: {
            name: this.personForm.name,
            givenName: this.personForm.givenName,
            familyName: this.personForm.familyName,
            email: this.personForm.email,
            phoneNumber: this.personForm.phoneNumber
          }
        }
      },
      debounce: 250,
      skip () {
        return !this.enablePersonSearch
      }
    }
  },

  methods: {
    onError (e) {
      this.$emit('error', e)
    },

    add () {
      this.personForm = {}
      this.linkageForm = {
        createAccount: true
      }
      this.isNew = true
      this.dialog = true
    },

    async disableLink (registrationPersonId) {
      this.saving = true
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation ($registrationPersonId: MongoID!, $registrationId: MongoID!) {
            person: registrationPersonUnlinkOne(registrationPersonId: $registrationPersonId, registrationId: $registrationId) {
              _id
              end
              isActive
            }
          }`,
          variables: {
            registrationPersonId,
            registrationId: this.registrationId
          }
        })
      } catch (e) {
        this.onError(e)
      } finally {
        this.saving = false
      }
      this.$apollo.queries.registration.refresh()
      this.$emit('updated')
    },

    async enableLink (registrationPersonId) {
      this.saving = true
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation ($registrationPersonId: MongoID!, $registrationId: MongoID!) {
            person: registrationPersonRelinkOne(registrationPersonId: $registrationPersonId, registrationId: $registrationId) {
              _id
              end
              isActive
            }
          }`,
          variables: {
            registrationPersonId,
            registrationId: this.registrationId
          }
        })
      } catch (e) {
        this.onError(e)
      } finally {
        this.saving = false
      }
      this.$apollo.queries.registration.refresh()
      this.$emit('updated')
    },

    async save () {
      this.saving = true

      try {
        if (this.isNew) {
          await this.saveNew()
        } else {
          await this.saveExisting()
        }
      } catch (e) {
        this.onError(e)
        return
      } finally {
        this.saving = false
      }

      this.dialog = false
      this.panel = 0
      this.$apollo.queries.registration.refresh()
      this.$emit('change')
    },

    async saveNew () {
      const personId = this.linkageForm.existingPersonId
      const person = {
        name: this.personForm.name,
        givenName: this.personForm.givenName,
        familyName: this.personForm.familyName,
        email: this.personForm.email,
        phoneNumber: this.personForm.phoneNumber
      }

      const isPrimaryContact = !this.registration.persons.some(o => o.isPrimaryContact)

      const payload = {
        registrationId: this.registrationId,
        position: this.linkageForm.position,
        createAccount: this.linkageForm.createAccount,
        isPrimaryContact
      }
      if (personId) {
        payload.personId = personId
      } else {
        payload.person = person
      }

      await this.$apollo.mutate({
        mutation: gql`mutation ($registrationId: MongoID!, $personId: MongoID, $person: CreateOnePersonInput, $position: String!, $createAccount: Boolean!, $isPrimaryContact: Boolean!) {
          registrationPersonAddOne(registrationId: $registrationId, personId: $personId, person: $person, position: $position, createAccount: $createAccount, isPrimaryContact: $isPrimaryContact) {
            _id
          }
        }`,
        variables: payload
      })
    },

    async saveExisting () {
      await this.$apollo.mutate({
        mutation: gql`mutation ($registrationId: MongoID!, $registrationPersonId: MongoID!, $linkage: MemberUpdateRegistrationPersonInput, $person: MemberUpdatePersonInput) {
          memberUpdateRegistrationPersonById(
            registrationId: $registrationId,
            registrationPersonId: $registrationPersonId,
            record: $linkage,
            personRecord: $person
          ) {
            _id
            position
            person {
              _id
              name
              givenName
              familyName
              email
              phoneNumber
            }
          }
        }`,
        variables: {
          registrationId: this.registrationId,
          registrationPersonId: this.linkageForm._id,
          linkage: {
            position: this.linkageForm.position
          },
          person: {
            name: this.personForm.name,
            givenName: this.personForm.givenName,
            familyName: this.personForm.familyName,
            email: this.personForm.email,
            phoneNumber: this.personForm.phoneNumber
          }
        }
      })
    },

    async startEndUserTraining (linkage) {
      this.saving = true
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation ($personId: MongoID!, $memberNumber: String!) {
            personInviteEndUser(personId: $personId, memberNumber: $memberNumber)
          }`,
          variables: {
            personId: linkage.person._id,
            memberNumber: this.registration.memberNumber
          }
        })
      } catch (e) {
        this.onError(e)
        return
      } finally {
        this.saving = false
      }
      this.$emit('info', 'End-user training invitation sent via email.')
    },

    openAssmentHistory (personId) {
      this.selectedPersonId = personId
      this.assessmentDialog = true
    },

    async toggleIsAdminForRegistration (linkage) {
      this.saving = true
      const val = !linkage.isAdminForRegistration
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation ($registrationId: MongoID!, $registrationPersonId: MongoID!, $isAdminForRegistration: Boolean!) {
            registrationPersonSetIsAdminForRegistration(registrationId: $registrationId, registrationPersonId: $registrationPersonId, isAdminForRegistration: $isAdminForRegistration) {
              _id
              isAdminForRegistration
            }
          }`,
          variables: {
            registrationId: this.registrationId,
            registrationPersonId: linkage._id,
            isAdminForRegistration: val
          }
        })
      } catch (e) {
        this.onError(e)
        return
      } finally {
        this.saving = false
      }
      const message = val
        ? `${linkage.person?.name} is now an administrator.`
        : `${linkage.person?.name} is no longer an administrator.`
      this.$emit('info', message)
    },

    async replacePrimaryContact (linkage) {
      this.saving = true
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation ($registrationId: MongoID!, $registrationPersonId: MongoID!) {
            registrationReplacePrimaryContact(registrationId: $registrationId, registrationPersonId: $registrationPersonId) {
              _id
              isPrimaryContact
              isAdminForRegistration
            }
          }`,
          variables: {
            registrationId: this.registrationId,
            registrationPersonId: linkage._id
          }
        })
      } catch (e) {
        this.onError(e)
        return
      } finally {
        this.saving = false
      }
      this.$emit('info', `${linkage.person?.name} is now the primary contact.`)
    },

    openEdit (linkage) {
      this.personForm = Object.assign({}, linkage.person)
      this.linkageForm = Object.assign({}, linkage)
      this.isNew = false
      this.dialog = true
    }
  }
}
</script>
